import React from 'react';
import { Balance as BalanceType, TokenInfo, TokenStats as TokenStatsType } from '../types';
import { formatQuantity } from '../utils/formatting';
import { AccountLink } from './AccountLink';
import './Balance.css';

interface BalanceProps {
    balance: BalanceType;
    tokenStats: TokenStatsType | null;
    asset: TokenInfo;
}

const Balance = React.memo<BalanceProps>(({ balance, tokenStats, asset }) => {
    return (
	<div className="balance">
	    <h2>{asset.symbol}</h2>
	    <div className="balance-content">
	        <span className="asset-name">{asset.name}</span>
	        <div className="label-value">
	            <span className="label">Mint:</span>
	            <AccountLink account={asset.mint} />
	        </div>
	        <div className="label-value">
	            <span className="label">Token Acct:</span>
	            <AccountLink account={balance.tokenAccountKey} />
	        </div>
	        <div className="label-value">
	            <span className="label">Liquidity:</span>
	            <span className="value">{formatQuantity(balance.balance)}</span>
	            <span className="label">({asset.symbol})</span>
	        </div>
	    </div>
	    {tokenStats && <TokenStats tokenStats={tokenStats} asset={asset}/>}
	</div>
    );
});

const TokenStats = React.memo<{tokenStats: TokenStatsType, asset: TokenInfo}>(({tokenStats, asset}) => {
    return (
        <div className="balance-content">
            <div className="balance-label-value">
                <span className="label">24H Swap Count:</span>
                <span className="value">{tokenStats.totalSwaps24h}</span>
            </div>
            <div className="balance-label-value">
                <span className="label">24H Volume:</span>
                <span className="value">{formatQuantity(tokenStats.totalVolume24h)}</span>
	        <span className="label">({asset.symbol})</span>
            </div>
            <div className="balance-label-value">
                <span className="label">24H Unique Trader Count:</span>
                <span className="value">{tokenStats.uniqueMakers24h + tokenStats.uniqueTakers24h}</span>
            </div>
	</div>
    );
});

function BalanceOrLoading({balance, tokenStats, asset}: {balance: BalanceType | null, tokenStats: TokenStatsType | null, asset: TokenInfo}) {
    return balance
        ? <Balance balance={balance} tokenStats={tokenStats} asset={asset} />
	: (
	    <div className="loading-placeholder">
	        <h3>Loading Balance...</h3>
	    </div>
	);
}

export default BalanceOrLoading;
